import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { FieldError as AriaFieldError } from "react-aria-components";
import { error } from "./FieldError.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseFieldError = (props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = /*#__PURE__*/_jsx(AriaFieldError, {
      ref: ref,
      className: error,
      ...props
    });
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export const FieldError = /*#__PURE__*/React.forwardRef(BaseFieldError);
//# sourceMappingURL=FieldError.js.map